import {combineReducers} from "redux"
import costProjection from "./projects/costProjection/modules"
import googleTrips from "./projects/googleTrips/modules"
import portal from "./projects/portal/modules"

// REDUCER
export default combineReducers({
  costProjection,
  googleTrips,
  portal,
})
